import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import SpinnerComponent from '../components/SpinnerComponent';
import * as Yup from 'yup';
import { User } from '../models/user';
import { UserService } from '../services/user.service';
import { MentorService } from '../services/mentor.service';
import { Mentor } from '../models/mentor';
import { RepresentativeService } from '../services/representative.service';
import { Representative } from '../models/representative';
import { Image } from 'react-bootstrap';

interface IState {
    user: User;
    mentors: Mentor[],
    representatives: Representative[],
    isLoading: boolean;
    isEdit: boolean;
    userHash: string;
}

export class UserEditPage extends React.Component<any, IState> {

    static readonly QRGeneratorApi = process.env.REACT_APP_QR_GENERATOR_API as string;

    constructor(props: any) {
        super(props);

        this.state = {
            user: new User(),
            mentors: new Array<Mentor>(),
            representatives: new Array<Representative>(),
            isLoading: false,
            isEdit: false,
            userHash: ''
        };
    }

    componentDidMount() {
        let id = this.props.match.params.id ? this.props.match.params.id : 0;

        if (id !== 0) {
            this.setState({ isLoading: true });

            UserService.getById(id)
                .then(
                    response => {

                        var userComputedHash = UserEditPage.QRGeneratorApi + response.token;
                        this.setState({
                            user: response,
                            userHash: userComputedHash,
                            isLoading: false,
                            isEdit: true
                        });
                    },
                    error => {
                        this.setState({ isLoading: false });
                    }
                );
        }

          MentorService.getAll()
            .then(
              response => {
                //add default select value to array
                var defaultMentor: Mentor = { id: 0, firstName: "odaberite ", lastName: "Mentora...", roles: []};
                response.unshift(defaultMentor);
                
                this.setState({
                  mentors: response
                });
              },
              error => {
                this.setState({ isLoading: false });
              }
          );
  
          RepresentativeService.getAll()
            .then(
              response => {
                //add default select value to array
                var defaultRepresentative: Representative = { id: 0, firstName: "odaberite ", lastName: "Zastupnika...", roles: []};
                response.unshift(defaultRepresentative);
                
                this.setState({
                  representatives: response
                });
              },
              error => {
                this.setState({ isLoading: false });
              }
          );
    }

    render() {
        return (
            <div className="col-md-6">
                {this.state.isEdit ?
                    <h1>Uredi korisnika</h1> : <h1>Registracija novog korisnika</h1>}
                {this.state.isLoading ? <SpinnerComponent /> : (
                    <Formik
                        initialValues={this.state.user}
                        validationSchema={Yup.object().shape({
                            firstName: Yup.string().required('Ime je potrebno'),
                            lastName: Yup.string().required('Prezime je potrebno'),
                            email: Yup.string().required('Email je potreban'),
                            password: this.state.isEdit ? Yup.string() : Yup.string().required('Lozinka je obavezna')
                        })}
                        onSubmit={(values, { setStatus, setSubmitting, setError }) => {
                            setStatus();
                            setError(null);

                            UserService.createOrUpdate(values)
                                .then(
                                    () => {
                                        setSubmitting(false);
                                        setStatus("Uspješno spremljeno!");
                                    },
                                    error => {
                                        setSubmitting(false);
                                        setError(error);
                                    }
                                );
                        }}
                        render={({ errors, status, touched, isSubmitting, error }) => (
                            <Form>
                                <div className="form-group">
                                    <label htmlFor="firstName">Ime</label>
                                    <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                                    <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="lastName">Prezime</label>
                                    <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                                    <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <Field name="email" type="email" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                                </div>
                                {!this.state.isEdit &&
                                    <div className="form-group">
                                        <label htmlFor="password">Lozinka</label>
                                        <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                        <ErrorMessage name="password" component="div" className="invalid-feedback" />
                                    </div>
                                }
                                <div className="form-group">
                                    <label htmlFor="phone">Telefon</label>
                                    <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} />
                                    <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="mentor">Odaberi Mentora</label>
                                    <Field name="mentorId" component="select" className={'form-control' + (errors.mentorName && touched.mentorName ? ' is-invalid' : '')} >
                                        {this.state.mentors.map((e, key) => {
                                            return <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>;
                                        })}
                                    </Field>
                                    <ErrorMessage name="mentorName" component="div" className="invalid-feedback" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="representative">Odaberi Zastupnika</label>
                                    <Field name="representativeId" component="select" className={'form-control' + (errors.representativeId && touched.representativeId ? ' is-invalid' : '')} >
                                        {this.state.representatives.map((e, key) => {
                                            return <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>;
                                        })}
                                    </Field>
                                    <ErrorMessage name="representativeId" component="div" className="invalid-feedback" />
                                </div>
                                {this.state.isEdit &&
                                    <div className="form-group">
                                        <label htmlFor="phone">Kod za povezivanje s mobilnom aplikacijom</label>
                                        <Image src={this.state.userHash} />
                                    </div>
                                }
                                <div className="form-group">
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                        {this.state.isEdit ?
                                            <span>Spremi</span> : <span>Registriraj novog korisnika</span>}
                                    </button>
                                    {isSubmitting &&
                                        <SpinnerComponent />
                                    }
                                </div>
                                {error &&
                                    <div className={'alert alert-danger'}>{error}</div>
                                }
                                {status &&
                                    <div className={'alert alert-success'}>{status}</div>
                                }
                            </Form>
                        )}
                    />
                )}
                <button
                    className="button icon-left"
                    onClick={this.props.history.goBack}>
                    Povratak
                </button>
            </div>
        )
    }
}